import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-privacy-policy-personalized',
  templateUrl: './privacyPolicyPersonalized.component.html',
  styleUrls: ['./privacyPolicyPersonalized.component.css']
})
export class PrivacyPolicyPersonalizedComponent implements OnInit {
  @Input() lang: any
  
  platform: any

  ngOnInit(): void {
    this.platform = localStorage.getItem('platform');
  }

}
